export const bytesToMB = (size: number, showUnits = false): string => {
    const _value = (size / Math.pow(10, 6)).toFixed(2);
    if (!showUnits) {
        return _value;
    }

    return _value + ' MB';
};
